import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "menu",
  "use": "menu-usage",
  "viewBox": "0 0 34 22",
  "content": "<symbol role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 22\" id=\"menu\">\n  <title>menu</title>\n  <g fill=\"#FFF\" fill-rule=\"evenodd\">\n    <rect width=\"34\" height=\"2\" rx=\"1\" />\n    <rect width=\"34\" height=\"2\" y=\"10\" rx=\"1\" />\n    <rect width=\"24\" height=\"2\" y=\"20\" rx=\"1\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol